var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGoogleCalendarLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    fill: "none",
    viewBox: "0 0 48 49",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24.75,
    r: 23.5,
    fill: "#fff",
    stroke: "#E8E8E8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M33.358 12.508H14.643c-.583 0-1.056.474-1.056 1.057v3.511h20.827v-3.511c0-.583-.474-1.057-1.056-1.057zm-14.412 2.113c-.28 0-.506-.226-.506-.505 0-.28.226-.506.505-.506.28 0 .506.227.506.506s-.227.505-.506.505zm10.241 0c-.279 0-.505-.226-.505-.505 0-.28.227-.506.506-.506s.505.227.505.506-.227.505-.506.505z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A5BBC",
    d: "M35.977 17.321l-1.597 8.33.652 8.662c.048.636-.455 1.179-1.093 1.179H14.06c-.638 0-1.141-.543-1.093-1.179l.653-8.662-1.598-8.33c-.15-.783.45-1.51 1.249-1.51h21.456c.799 0 1.4.727 1.249 1.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#518EF8",
    d: "M33.94 35.492H14.06c-.637 0-1.14-.543-1.093-1.179l.653-8.662H34.38l.652 8.662c.048.636-.454 1.179-1.093 1.179z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.596 23.478c0-1.626-1.361-2.95-3.033-2.95-1.673 0-3.033 1.324-3.033 2.95h1.01c0-1.069.908-1.938 2.023-1.938 1.115 0 2.022.87 2.022 1.938s-.907 1.937-2.022 1.937h-.944v1.011h.944c1.115 0 2.022.87 2.022 1.938 0 1.069-.907 1.938-2.022 1.938-1.115 0-2.022-.87-2.022-1.938H17.53c0 1.626 1.36 2.949 3.033 2.949 1.672 0 3.033-1.323 3.033-2.949 0-1.015-.531-1.913-1.337-2.443.806-.53 1.337-1.428 1.337-2.443zM25.56 22.252l.52.868 1.998-1.195v8.882h1.01V20.144l-3.527 2.108z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 12h24v24H12V12z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGoogleCalendarLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/google_calendar_logo.bd2f1414.svg";
export { ForwardRef as ReactComponent };